import { useState, useCallback } from 'react';
import type { RequestState } from '@typings/request';
import type { Patch } from '@typings/utils';

export function useBoolean(init: boolean): [boolean, (v?: boolean) => void] {
  const [value, setValue] = useState(init);

  const toggle = (v?: boolean) => setValue(s => (typeof v === 'boolean' ? v : !s));

  return [value, toggle];
}

export const usePatchState = <T extends unknown>(
  defaultState?: RequestState<T>
): [RequestState<T>, (p: Patch<RequestState<T>>) => void] => {
  const [state, updateState] = useState(defaultState);
  const patchState = useCallback((p: Patch<RequestState<T>>) => updateState(s => ({ ...s, ...p(s) })), [updateState]);
  return [state, patchState];
};

export * from './useBigLineHeight';
export * from './useLocalStorage';
export * from './useQuery';
export * from './useRequest';
export * from './useSettings';
export * from './useSupportVersionToast';
export * from './useTimeout';
export * from './useTranslate';
export * from './useUpdateEffect';
